import { render, staticRenderFns } from "./SetupObjectForm.vue?vue&type=template&id=3c45c9ec&scoped=true"
import script from "./SetupObjectForm.vue?vue&type=script&lang=js"
export * from "./SetupObjectForm.vue?vue&type=script&lang=js"
import style0 from "./SetupObjectForm.vue?vue&type=style&index=0&id=3c45c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45c9ec",
  null
  
)

export default component.exports